// @ts-nocheck
import React from "react";
import { FaPhoneAlt, FaClock, FaMapMarkerAlt } from "react-icons/fa";
import hiraLogo from "../assets/images/hira-logo.jpeg";
import { useLanguageContext } from "../context/languageContext";
import { BUSINESS } from "../data";

const CONTACT_PHONE = "+355 68 226 2000";
const CONTACT_PHONE_RAW = "355682262000";

/**
 * Contact card at the foot of the page.
 *
 * Deliberately quiet: a neutral card with a thin brand edge rather than a large
 * block of colour, so it reads as practical information and not as an advert.
 */
export const SubBanner = () => {
    const { t } = useLanguageContext();
    const business = BUSINESS;
    // The stored address usually names the city already ("Shkozet, Durres"), and it is
    // typed by hand, so tidy the spacing and only add the city when it is missing.
    const street = (business.address || "").replace(/\s+,/g, ",").replace(/\s+/g, " ").trim();
    const city = (business.city || "").trim();
    const address = city && !new RegExp(city, "i").test(street)
        ? [street, city].filter(Boolean).join(", ")
        : street;
    const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent([business.businessName, address].filter(Boolean).join(" "))}`;

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="rounded-2xl bg-white border border-slate-200/70 shadow-[0_2px_12px_-8px_rgba(0,0,0,0.15)] overflow-hidden">
                <div className="h-[3px] bg-brand"></div>

                <div className="p-4 space-y-3.5">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-9 flex-shrink-0 rounded-lg bg-white border border-slate-100 flex items-center justify-center p-1">
                            <img src={hiraLogo} alt="Piceri Hira" className="max-w-full max-h-full object-contain" />
                        </div>
                        <div className="min-w-0">
                            <p className="text-[13px] font-bold text-slate-900 leading-tight truncate">
                                {business.businessName || "Piceri Hira"}
                            </p>
                            <p className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400">
                                Bar Restorant &amp; Piceri
                            </p>
                        </div>
                    </div>

                    <div className="space-y-2 pt-0.5">
                        {address && (
                            <a
                                href={mapsUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-start gap-2.5 text-slate-600 active:text-brand transition-colors"
                            >
                                <FaMapMarkerAlt className="text-brand mt-[3px] flex-shrink-0" size={11} />
                                <span className="text-[11.5px] font-medium leading-snug">{address}</span>
                            </a>
                        )}
                        <div className="flex items-center gap-2.5 text-slate-600">
                            <FaClock className="text-brand flex-shrink-0" size={11} />
                            <span className="text-[11.5px] font-medium">
                                {t("Delivery & Catering", "Delivery & Catering")}
                            </span>
                        </div>
                    </div>

                    <a
                        href={`tel:+${CONTACT_PHONE_RAW}`}
                        className="flex items-center justify-center gap-2 h-11 rounded-xl bg-brand text-white text-[11px] font-black uppercase tracking-widest active:scale-[0.98] transition-transform"
                    >
                        <FaPhoneAlt size={11} />
                        {CONTACT_PHONE}
                    </a>
                </div>
            </div>
        </section>
    );
};
